import { render, staticRenderFns } from "./search.vue?vue&type=template&id=0984ecac&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0984ecac",
  null
  
)

export default component.exports